const features = [
  {
    icon: 'ri-arrow-down-line',
    title: '下拉式竖屏阅读',
    desc: '专为手机优化的竖屏滚动阅读体验，像刷短视频一样自然流畅。告别传统翻页打断，漫画故事一气呵成，沉浸感拉满。',
    color: 'bg-primary-100/70 text-primary-700',
  },
  {
    icon: 'ri-download-cloud-line',
    title: '离线缓存随时看',
    desc: '支持一键缓存整部漫画，地铁上、旅途中没有网络也能畅快追更。智能缓存管理，不占空间，想看就看。',
    color: 'bg-accent-100/70 text-accent-700',
  },
  {
    icon: 'ri-global-line',
    title: '韩漫日漫国漫全覆盖',
    desc: '三大品类一网打尽，从热血格斗到甜宠恋爱，从玄幻修仙到悬疑推理，热门连载与经典完结全部免费畅读。',
    color: 'bg-secondary-100/70 text-secondary-700',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">为什么选择番茄漫画</h2>
          <p className="text-foreground-500 text-sm mt-2 max-w-lg mx-auto">
            三大核心优势，为你打造最好的漫画阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((feature, i) => (
            <div
              key={i}
              className="rounded-xl bg-background-100 border border-background-200/70 p-6 text-center hover:border-primary-200 transition-all duration-300 cursor-pointer group"
            >
              <div className={`w-14 h-14 rounded-xl ${feature.color} flex items-center justify-center mx-auto mb-5 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${feature.icon} text-2xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-3">{feature.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}